"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiImpacteesParCorporationTrads = void 0;
exports.ESubScpiImpacteesParCorporationTrads = {
    desDeux: "Des deux",
    evolutionLoyer: "L'évolution des loyers",
    evolutionMarcheImmo: "L'évolution du marché immobilier",
};
